import { render, staticRenderFns } from "./StoreUserRequestComponent.vue?vue&type=template&id=52b9e909&scoped=true"
import script from "./StoreUserRequestComponent.vue?vue&type=script&lang=js"
export * from "./StoreUserRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9e909",
  null
  
)

export default component.exports